import React, { Component, useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";
import { component } from "picoapp";
import { useCartContents } from "@src/hooks";
import { ReactDrawer } from "../../parts";
import CartList from "./CartList";
import MiniCartButton from "./MiniCartButton";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useQueryClient,
} from "react-query";
import pluralize from "pluralize";

const queryClient = new QueryClient();

const MiniCart = ({ node, ctx }) => {
  const [open, setOpen] = useState(false);
  const { status, data: cartContents, error, isLoading } = useCartContents();
  const [upsellCollection, setUpsellCollection] = useState(null);
  const queryClient = useQueryClient();

  // Update cart and open when adding to cart
  useEffect(() => {
    ctx.on("cart.update", (state) => {
      queryClient.invalidateQueries("cart");
      if (
        window.location.pathname !== "/cart" &&
        window.location.pathname !== "/collections/color-match-kit"
      ) {
        setOpen(true);
      }
    });
    setUpsellCollection(node.dataset.upsellCollection);
  }, []);

  useEffect(() => {
    if (cartContents) {
      ctx.hydrate({
        systemCart: cartContents,
        cartContents: {
          items: cartContents.items,
          item_count: cartContents.item_count,
        },
      });
    }
  }, [cartContents]);

  if (isLoading) {
    return null;
  }

  const { items, item_count } = cartContents;

  return (
    <>
      <MiniCartButton
        handleClick={setOpen}
        open={open}
        itemCount={item_count}
      ></MiniCartButton>
      <ReactDrawer
        id="miniCartDrawer"
        showDrawer={open}
        setShowDrawer={setOpen}
        position={"right"}
      >
        <header className="Drawer__header">
          <h3>
            your cart ({item_count} {pluralize("item", item_count)})
          </h3>
          <button
            type="button"
            className="Button"
            data-layout="noLayout"
            onClick={() => setOpen(!open)}
            aria-label="Close"
          >
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#close"></use>
            </svg>
          </button>
        </header>

        <CartList
          data={cartContents}
          setShowDrawer={setOpen}
          upsellCollection={upsellCollection}
        />
      </ReactDrawer>
    </>
  );
};

const MiniCartProvider = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <MiniCart {...props}></MiniCart>
    </QueryClientProvider>
  );
};

export default component((node, ctx) => {
  const element = <MiniCartProvider ctx={ctx} node={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
